import Swiper from 'swiper';
import { Autoplay } from 'swiper';

const setGallerySlider = () => {
  const targetSliders = document.querySelectorAll(".js-gallery-slider");

  targetSliders.forEach(gallerySlider => {
    var swiper = new Swiper(gallerySlider, {
      modules: [Autoplay],
      allowTouchMove: false,
      autoplay: {
        disableOnInteraction: false,
        delay: 0,
      },
      speed: 20000,
      loop: true,
      slidesPerView: 'auto',
    });
  })
}

export default setGallerySlider;